import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../Components/api/axiosInstance";

const toTitleCase = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const AddEditRestaurantMaster = ({
  editingData,
  onClose,
  onSuccess,
  groupId,
  groupName,
  userId,
}) => {
  const [form, setForm] = useState({
    id: "",
    restId: 0,
    restaurantName: "",
    brandName: groupName || "", 
    contactPersonName: "",
    contactPersonMobile: "",
    contactPersonEmail: "",
    biometricId: "", // ✅ NEW FIELD
    maxEmployees: 0,
    status: true,
  });

  const [saving, setSaving] = useState(false);

  // refs
  const nameRef = useRef(null);
  const brandRef = useRef(null);
  const contactRef = useRef(null);
  const mobileRef = useRef(null);
  const emailRef = useRef(null);
  const biometricRef = useRef(null); // ✅ NEW REF
  const maxEmpRef = useRef(null);
  const statusRef = useRef(null);
  const saveRef = useRef(null);

  // Load edit data
useEffect(() => {
  if (editingData) {
    setForm((prev) => ({
      ...prev,
      ...editingData,
      biometricId: editingData.biometricId || "",
      maxEmployees: editingData.maxEmployees ?? 0,
      status: editingData.status ?? true,
    }));
  }
}, [editingData]);

  // Auto focus first input
  useEffect(() => {
    const t = setTimeout(() => {
      if (nameRef.current) {
        nameRef.current.focus();
        if (editingData?.restaurantName) nameRef.current.select();
      }
    }, 100);
    return () => clearTimeout(t);
  }, [editingData]);

  const handleAutoSelect = (ref) => {
    setTimeout(() => ref?.current?.select(), 0);
  };

  const handleKeyDown = (e, nextRef, prevRef, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      } else if (isLast) {
        handleSubmit();
      }
    }

    if (e.key === "Escape") {
      e.preventDefault();
      if (prevRef?.current) prevRef.current.focus();
      else onClose?.();
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "contactPersonMobile" && value.length > 10) return;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleBlurFormat = (e) => {
    const { name, value } = e.target;

    if (
      ["restaurantName", "brandName", "contactPersonName"].includes(name)
    ) {
      setForm((prev) => ({ ...prev, [name]: toTitleCase(value) }));
    }
  };

  const handleSubmit = async () => {
    if (!form.restaurantName.trim()) {
      alert("Restaurant Name required");
      nameRef.current?.focus();
      return;
    }

    // ✅ optional biometric validation (remove if not required)
    if (!form.biometricId.trim()) {
      alert("Biometric ID required");
      biometricRef.current?.focus();
      return;
    }

    if (form.contactPersonMobile && form.contactPersonMobile.length !== 10) {
      alert("Mobile must be 10 digits");
      mobileRef.current?.focus();
      return;
    }

    if (form.contactPersonEmail && !isValidEmail(form.contactPersonEmail)) {
      alert("Invalid email");
      emailRef.current?.focus();
      return;
    }

    setSaving(true);

    const payload = {
      ...form,
      groupId,
      activeSubscriptionId: null,
      createdBy: userId,
      modifiedBy: userId,
      entryDate: form.entryDate || new Date().toISOString(),
      lastModifyDate: new Date().toISOString(),
    };

    try {
      await axiosInstance.post(
        "/RestaurantMaster/UpsertRestaurant",
        payload
      );
      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error(err);
      alert("Failed to save restaurant");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
  if (groupName) {
    setForm((prev) => ({
      ...prev,
      brandName: groupName,
    }));
  }
}, [groupName]);

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6 border"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-bold mb-5">
          {form.id ? "Edit Restaurant" : "Add Restaurant"}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Restaurant Name */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Restaurant Name <span className="text-red-500">*</span>
            </label>
            <input
              ref={nameRef}
              type="text"
              name="restaurantName"
              value={form.restaurantName}
              onChange={handleChange}
              onBlur={handleBlurFormat}
              onFocus={() => handleAutoSelect(nameRef)}
              onKeyDown={(e) => handleKeyDown(e, brandRef, null)}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Brand */}
         {/* Brand */}
<div>
  <label className="block text-sm font-medium text-slate-700 mb-1">
    Brand Name
  </label>
  <input
    ref={brandRef}
    type="text"
    name="brandName"
    value={form.brandName}
    onChange={handleChange}
    onBlur={handleBlurFormat}
    onFocus={() => handleAutoSelect(brandRef)}
    onKeyDown={(e) => handleKeyDown(e, contactRef, nameRef)}
    className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
  />
</div>

          {/* Contact Person */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Contact Person
            </label>
            <input
              ref={contactRef}
              type="text"
              name="contactPersonName"
              value={form.contactPersonName}
              onChange={handleChange}
              onBlur={handleBlurFormat}
              onFocus={() => handleAutoSelect(contactRef)}
              onKeyDown={(e) => handleKeyDown(e, mobileRef, brandRef)}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Mobile */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Mobile
            </label>
            <input
              ref={mobileRef}
              type="number"
              name="contactPersonMobile"
              value={form.contactPersonMobile}
              onChange={handleChange}
              onFocus={() => handleAutoSelect(mobileRef)}
              onKeyDown={(e) => handleKeyDown(e, emailRef, contactRef)}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Email
            </label>
            <input
              ref={emailRef}
              type="email"
              name="contactPersonEmail"
              value={form.contactPersonEmail}
              onChange={handleChange}
              onFocus={() => handleAutoSelect(emailRef)}
              onKeyDown={(e) => handleKeyDown(e, biometricRef, mobileRef)}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* ✅ Biometric ID */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Biometric ID
            </label>
            <input
              ref={biometricRef}
              type="text"
              name="biometricId"
              value={form.biometricId}
              onChange={handleChange}
              onFocus={() => handleAutoSelect(biometricRef)}
              onKeyDown={(e) => handleKeyDown(e, maxEmpRef, emailRef)}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Max Employees */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Max Employees
            </label>
            <input
              ref={maxEmpRef}
              type="number"
              name="maxEmployees"
              value={form.maxEmployees}
              onChange={handleChange}
              onFocus={() => handleAutoSelect(maxEmpRef)}
              onKeyDown={(e) => handleKeyDown(e, statusRef, biometricRef)}
              className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Status */}
          <div className="flex items-center gap-2 mt-2 md:mt-6">
            <input
              ref={statusRef}
              type="checkbox"
              name="status"
              checked={form.status}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, saveRef, maxEmpRef, true)}
            />
            <label className="text-sm font-medium text-slate-700">
              Active
            </label>
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-500 text-white hover:bg-gray-600"
          >
            Cancel
          </button>

          <button
            ref={saveRef}
            onClick={handleSubmit}
            disabled={saving}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSubmit();
              else handleKeyDown(e, null, statusRef);
            }}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditRestaurantMaster;